<div class="certificate" (click)="openInfo(certificate)">
  <div class="certificate-value">{{this.certificate.amount  + ' \u20AC'}}</div>

  <image  class="certificate-image" [imageLink]="certificate.photo"></image>

</div>
